const STORAGE_KEY_PREFIX = "hackle:selected-client:";

export const SUPER_USER_GROUPS = ["Developer Administrators", "Super user"];

export const accessorCanSelectClient = accessor =>
  Boolean(
    accessor?.groups?.some(group =>
      SUPER_USER_GROUPS.includes(group.groupName),
    ),
  );

const storageKey = userUid => `${STORAGE_KEY_PREFIX}${userUid}`;

const normalizeClient = client => {
  if (!client || typeof client !== "object" || !client.value) return null;
  return {
    value: String(client.value),
    label: client.label ? String(client.label) : String(client.value),
    ...(client.logo ? { logo: String(client.logo) } : {}),
  };
};

export const readSelectedClient = userUid => {
  if (!userUid || typeof window === "undefined") return undefined;
  try {
    const raw = window.localStorage.getItem(storageKey(userUid));
    if (raw == null) return undefined;
    if (raw === "null") return null;
    return normalizeClient(JSON.parse(raw));
  } catch {
    return undefined;
  }
};

export const writeSelectedClient = (userUid, client) => {
  if (!userUid || typeof window === "undefined") return;
  try {
    const normalized = normalizeClient(client);
    window.localStorage.setItem(
      storageKey(userUid),
      normalized ? JSON.stringify(normalized) : "null",
    );
    if (normalized) pushRecentClient(userUid, normalized);
  } catch {
    // Ignore quota / private-mode failures.
  }
};

const RECENTS_KEY_PREFIX = "hackle:recent-clients:";
const MAX_RECENTS = 4;

const recentsKey = userUid => `${RECENTS_KEY_PREFIX}${userUid}`;

export const readRecentClients = userUid => {
  if (!userUid || typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(recentsKey(userUid));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map(normalizeClient).filter(Boolean).slice(0, MAX_RECENTS);
  } catch {
    return [];
  }
};

export const pushRecentClient = (userUid, client) => {
  const normalized = normalizeClient(client);
  if (!userUid || !normalized) return;
  try {
    const next = [
      normalized,
      ...readRecentClients(userUid).filter(item => item.value !== normalized.value),
    ].slice(0, MAX_RECENTS);
    window.localStorage.setItem(recentsKey(userUid), JSON.stringify(next));
  } catch {
    // Ignore quota / private-mode failures.
  }
};

export const clientLogoFromApi = item => {
  if (!item) return undefined;
  const custom = item.custom_data || item.customData || {};
  return (
    item.logo ||
    item.logoUrl ||
    item.logo_url ||
    custom.logo ||
    custom.logoUrl ||
    undefined
  );
};
